module.exports = __webpack_public_path__ + "img/0Q3A5746_L_Black.156cd825.jpg";